import { AutoStoriesOutlined } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'redux/store';

import { getPromptsIncrementally } from '../../redux/actions/promptActions';
import {
  selectPrompts,
  setPage,
  setSearchQuery,
  setSelectedLabels,
} from '../../redux/reducers/promptReducer';
import { StyledIconButton } from '../../theme/CustomComponents';
import { Prompt } from '../../Types/prompt';
import { useDrawer } from '../Providers/DrawerProvider';
import PromptCardDetails from './PromptCardDetails';
import PromptList from './PromptList';

const PromptListDrawer = () => {
  const { closeDrawer } = useDrawer();
  const dispatch = useDispatch<AppDispatch>();

  const [prompt, setPrompt] = useState<Prompt | null>(null);

  const { searchQuery, selectedLabels } = useSelector(selectPrompts);

  const handleCardClick = useCallback((prompt: Prompt) => {
    setPrompt(prompt);
  }, []);

  useEffect(() => {
    dispatch(getPromptsIncrementally({ pageAction: 'reset' }));
  }, [searchQuery, selectedLabels, dispatch]);

  // Clear the filters when the components unmounts so the state does not stay
  // dirty for other components that use these filters like the prompts page
  useEffect(
    () => () => {
      dispatch(setSearchQuery(''));
      dispatch(setSelectedLabels([]));
      dispatch(setPage(1));
    },
    [dispatch]
  );

  return (
    <Box display="flex" position="relative" flexDirection="column" pt="150px">
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          paddingX: '48px',
          paddingY: '44px',
          justifyContent: 'space-between',
          borderBottom: '1px solid #CED7E6',
          marginBottom: '16px',
          position: 'fixed',
          width: 'stretch',
          top: 0,
          backgroundColor: 'white',
          zIndex: 10,
        }}
      >
        <Box sx={{ display: 'flex', gap: 1 }}>
          <AutoStoriesOutlined sx={{ height: '28px', width: '28px', color: '#070154' }} />
          <Typography variant="h5">Library</Typography>
        </Box>
        <StyledIconButton onClick={closeDrawer}>
          <CloseIcon />
        </StyledIconButton>
      </Box>
      {prompt ? (
        <PromptCardDetails prompt={prompt} onBack={() => setPrompt(null)} />
      ) : (
        <PromptList onCardClick={handleCardClick} />
      )}
    </Box>
  );
};

export default PromptListDrawer;
